import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { AdBlockDetectorModule } from "./ad-block-detector";
import { CrossStorageModule } from "./cross-storage";
import { ElementContainerModule } from "./element-container";
import { FileSaverModule } from "./file-saver";
import { GrowlServiceModule } from "./growl-service";
import { ModalsModule } from "./modals";
import { OverlaysModule } from "./overlays";
import { PipeServicesModule } from "./pipe-services";
import { RuntimeConfigModule } from "./runtime-config";
import { ScrollToModule } from "./scroll-to";

@NgModule({
  imports: [CommonModule],
  exports: [
    AdBlockDetectorModule,
    CrossStorageModule,
    ElementContainerModule,
    OverlaysModule,
    ModalsModule,
    FileSaverModule,
    GrowlServiceModule,
    OverlaysModule,
    RuntimeConfigModule,
    PipeServicesModule,
    ScrollToModule
  ]
})
export class LanternCoreUtilsModule {}
